import {formatoFechaExportacion} from "../../Utilidades/formatoFechaExportacion";

export const adaptador_reservas_exportacion = (reservas) => {


    let arr = []
    for (let i = 0; i < reservas.length; i++) {
        let reserva = reservas[i]
        let obj = {
            TipoID: reserva.tipoCc,
            NumeroID: reserva.cc,
            Nombres: reserva.nombres ? reserva.nombres.toUpperCase() : '',
            Apellidos: reserva.apellidos ? reserva.apellidos.toUpperCase() : '',
            CiudadResidencia: reserva.ciudad,
            CiudadProcedencia: reserva.ciudadProcendencia,
            NumHabitacion: reserva.numero,
            MotivoViaje: reserva.motivo,
            NumAcompanantes: reserva.acompanantes ? reserva.acompanantes.length : 0,
            CheckIn: reserva.fechaCheckIn ? formatoFechaExportacion(reserva.fechaCheckIn) : '',
            CheckOut: reserva.fechaCheckOut ? formatoFechaExportacion(reserva.fechaCheckOut) : '',
            Acomodacion: reserva.tipo,
            Valor: reserva.valor

        }
        arr.push(obj)
    }

    return arr

}